export default __webpack_public_path__ + "static/media/shield-lock.29f951ef.svg";